import React, {Component} from 'react';




class GetStartedInfo extends Component{

    componentDidMount() {
      }

    render(){
        return(
            <div className="get-started-info">
                <div className="text-center project-benefits">
                    <h4 className="info-title">جدوى لـ3 سنوات</h4>
                    <div className="benefits-container">
                        <p className="benefit">معدل ربح سنوي</p>
                        <p className="benefit">غير متوفر فترة استرداد رأس المال</p>
                        <p className="benefit">غير متوفر معدل الحصة السوقية</p>
                    </div>
                 </div>
                 <div className="swiper-container get-start-slider">
                        <h4 className="info-title">تمويل المشروع</h4>
                        <div className="swiper-arrows-container">
                            <div className="swiper-button-next get-start-next-btn get-start-slider-btn"></div>
                            <div className="swiper-button-prev get-start-prev-btn get-start-slider-btn"></div>
                        </div>
                        <div className="swiper-wrapper">
                            <div className="swiper-slide">
                                <div className="benefits-container">
                                    <p className="benefit">رأس مال المشروع</p>
                                    <p className="benefit">مديونية لتمويل رأس المال</p>
                                    <p className="benefit">تمويل خاص للمشروع</p>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="benefits-container">
                                    <p className="benefit">معدل ربح سنوي</p>
                                    <p className="benefit">غير متوفر فترة استرداد رأس المال</p>
                                    <p className="benefit">غير متوفر معدل الحصة السوقية</p>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="benefits-container">
                                    <p className="benefit">رأس مال المشروع</p>
                                    <p className="benefit">مديونية لتمويل رأس المال</p>
                                    <p className="benefit">تمويل خاص للمشروع</p>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="benefits-container">
                                    <p className="benefit">معدل ربح سنوي</p>
                                    <p className="benefit">غير متوفر فترة استرداد رأس المال</p>
                                    <p className="benefit">غير متوفر معدل الحصة السوقية</p>
                                </div>
                            </div>
                        </div>
                 </div>
                 <div className="text-center">
                    <a className="get-start-btn light-btn" href="/home">حفظ</a>
                    <a className="get-start-btn" href="/home">إعرض</a>
               </div>

            </div>
        );
    }

};
export default GetStartedInfo;
